import * as types from './mutation-types'
import router from '@/router'
import i18n from '@/i18n'
import { useFavicon } from '@vueuse/core'

function getRouterDocumentTitle () {
  return router.currentRoute.name
    ? 'Spedimo - ' + i18n.t(`documentTitle.${router.currentRoute.name.toLowerCase()}`) || ''
    : 'Spedimo'
}

function getActiveDocumentTitle (state) {
  return state.documentTitleBase || getRouterDocumentTitle()
}

export default {
  [types.LOADING] (state) {
    state.loading = false
  },
  [types.LOADED] (state) {
    state.loading = false
  },
  [types.LOGIN] (state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn
  },
  [types.ENUMS] (state, data) {
    state.enums = data
  },
  [types.SET_SNACKBAR] (state, snackBar) {
    state.snackBar = { ...state.snackBar, ...snackBar }
  },
  [types.SET_NOTIFICATION_DIALOG] (state, notificationDialog) {
    state.notificationDialog = {
      ...state.notificationDialog,
      ...notificationDialog
    }
  },
  [types.SET_USER_COMMON_DATA] (state, data) {
    state.userCommonData = data
  },
  [types.SET_LANGUAGES] (state, data) {
    state.languages = data
  },
  [types.SET_CURRENCIES] (state, data) {
    state.currencies = data
  },
  [types.SET_COUNTRIES] (state, data) {
    state.countries = data
  },
  [types.REFRESH_CONTACTS] (state, data) {
    state.contacts = data
  },
  [types.HELP] (state, data) {
    state.helpConversations = data
  },
  [types.CONTACT_CHANGE] (state, { userId, showCooperationState, cooperationState }) {
    const contact = state.contacts.contacts.find((user) => user.user.id === userId
    )
    if (contact) {
      contact.cooperationStatus = cooperationState
      contact.showCooperationStatus = showCooperationState
    }
    state.contacts.groups.forEach(element => {
      const user = element.users.find((el) => el.user.id === userId)
      if (user) {
        user.cooperationStatus = cooperationState
        user.showCooperationStatus = showCooperationState
      }
    })
  },
  [types.SET_DOCUMENT_TITLE_BASE] (state, title) {
    state.documentTitleBase = title || null
  },
  [types.SET_TITLE_NOTIFICATION_INTERVAL] (state) {
    if (state.titleNotificationInterval) {
      return
    }
    const icon = useFavicon()
    icon.value = 'static/img/favicon_red.png'
    state.titleNotificationInterval = setInterval(() => {
      if (document.title === i18n.t('documentTitle.newMessage')) {
        document.title = getActiveDocumentTitle(state)
      } else {
        document.title = i18n.t('documentTitle.newMessage')
      }
    }, 2000)
  },
  [types.SET_TSL_ORDER_PRE_FILL] (state, data) {
    state.tslOrderPreFill = data
  },
  [types.CLEAR_TITLE_NOTIFICATION_INTERVAL] (state) {
    const icon = useFavicon()
    icon.value = 'static/img/favicon.png'
    document.title = getActiveDocumentTitle(state)
    clearInterval(state.titleNotificationInterval)
    state.titleNotificationInterval = null
  }
}
